import { Project } from '@/shared/config/projects';
import { axiosInstance } from '@/shared/core';
import { projectAxios } from '@/shared/core/axios';

import { GetBooksParamsDTO, GetBooksResponseDTO } from './dto/books.dto';

export async function getBooks(
  project: Project,
  params: GetBooksParamsDTO,
): Promise<GetBooksResponseDTO> {
  if (project === 'kitaba') {
    const response = (
      await projectAxios.kitaba.get('/books', {
        params: {
          limit: params.limit,
          offset: params.offset,
          search: params.search,
          category_id: params.categoryIds?.[0],
          publisher_id: params.publisherId,
          author_id: params.authorId,
          is_published: params.published,
        },
      })
    ).data;

    return {
      count: response.count,
      books: response.books.map(
        (book: {
          id: number;
          author: { name: string };
          title: string;
          isPublished: boolean;
          coverUrl: string;
          categories?: { id: number }[];
        }) => ({
          id: book.id,
          author: book.author.name,
          title: book.title,
          isPublished: book.isPublished,
          description: '',
          imgUrl: book.coverUrl,
          circleImgUrl: '',
          translatorName: '',
          readerName: '',
          categoryIds: (book.categories || []).map((category) => category.id),
        }),
      ),
    };
  }

  return (
    await axiosInstance.get('/book/getAll', {
      params: {
        limit: params.limit,
        offset: params.offset,
        search: params.search,
        categoryIds: params.categoryIds,
        published: params.published,
        publisherId: params.publisherId,
      },
    })
  ).data;
}
